import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const JotformFormRecoveryPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-grow">
        <section className="py-16 md:py-24 border-b">
          <div className="container mx-auto px-6 max-w-4xl">
            <p className="text-sm font-semibold text-primary mb-3">Form recovery</p>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground">
              Jotform form recovery starts with independent backups
            </h1>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
              If a form is deleted, corrupted, or changed unexpectedly, recovery depends on having
              a usable backup from before the incident. FAB stores Jotform form structure backups
              so teams can create a restored copy from a previous version.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button asChild size="lg">
                <Link to="/jotform-restore">How Restore Works</Link>
              </Button>
              <Button asChild size="lg" variant="outline">
                <Link to="/auth?mode=signup">Start Protection</Link>
              </Button>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20">
          <div className="container mx-auto px-6 max-w-4xl prose prose-gray dark:prose-invert">
            <h2>Common recovery scenarios</h2>
            <ul>
              <li>A critical Jotform form is deleted or archived by mistake.</li>
              <li>A field, condition, webhook, or setting is changed and needs to be rebuilt.</li>
              <li>A team needs to inspect an older form version before shipping updates.</li>
              <li>An operator wants downloadable backup JSON for audit or migration review.</li>
            </ul>

            <h2>Recovery limits</h2>
            <p>
              FAB is designed around form structure recovery. It does not recover Jotform
              submissions, respondent file uploads, or payment details from submitted entries.
            </p>

            <h2>Best practice</h2>
            <p>
              Turn on automated backups before major edits, then create a manual backup immediately
              before high-risk changes. That gives your team a recent recovery point if the form
              needs to be recreated.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default JotformFormRecoveryPage;
